import { render, staticRenderFns } from "./trace.vue?vue&type=template&id=f5965084&"
import script from "./trace.vue?vue&type=script&lang=ts&"
export * from "./trace.vue?vue&type=script&lang=ts&"
import style0 from "./trace.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports